var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":false,"showFilter":false,"showSearch":true,"showExportation":false}},[_vm._v("بوليصات التأمين")]),_c('main-table',{attrs:{"baseURL":_vm.VUE_APP_INSURANCE_LINK,"fields":_vm.fields,"list_url":"insurances"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }